import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminAssetFormatsAssetFormatRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ asset_format_id }) {
    const { content } = await this.store.request(
      findRecord('asset-format', asset_format_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
